import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledBreadcrumbs = styled('nav')(
  ({ theme }) => css`
    margin-top: 24px;
    font-family: inherit;
    display: flex;
    a,
    a:visited,
    a:-webkit-any-link {
      color: ${theme.palette.secondary.lighter};
      text-align: right;
      font-size: ${theme.typography.button.fontSize};
      font-style: normal;
      font-weight: ${theme.typography.button.fontWeight};
      line-height: ${theme.typography.button.lineHeight};
    }
    a.active {
      cursor: default;
    }
  `
);
